import { Auth } from 'aws-amplify';

type EditProfileData = {
  nickname?: string,
  name?: string,
  family_name?: string
  ['custom:privacy_policy']?: string,
};

export default async function editProfile(userProfileData: EditProfileData): Promise<undefined | string | unknown> {
  try {
    const user = await Auth.currentAuthenticatedUser();
    try {
      const result = await Auth.updateUserAttributes(user, { ...userProfileData });
      if (result === 'SUCCESS') return 'SUCCESS';
    } catch (error) {
      console.log('error while editing user attributes', error);
      return error;
    }
  } catch (error) {
    console.log('error while retrieving user', error);
  }
}
